import { InfoValue } from "@/services/channels/types";

export interface Zone {
    id: string,
    name: string;
    width: number;
    height: number;
    x: number;
    y: number;
}

export interface ZoneDto {
    name: string;
    width: number;
    height: number;
    x: number;
    y: number;
}

export interface Content {
    id: string;
    name: string;
    x: number;
    y: number;
    layer: number;
    contentId: string;
    type: ContentType;
    typeName: string;
    status: ContentStatusEnum;
}

export interface ContentDto {
    name: string;
    x: number;
    y: number;
    layer: number;
    channelId?: string,
    channelGroupId?: string;
    status: ContentStatusEnum;
}

export interface Background {
    id: string;
    name: string;
    width: number;
    height: number;
    backgroundBaseId: string;
    backgroundBaseName: string;
    folderId: string;
    content: Array<ContentDto>;
    zones: Array<ZoneDto>;
}

export interface Settings {
    name: string,
    width: number;
    height: number;
    backgroundBaseId: string;
    backgroundBaseName: string;
}

export enum ContentType {
    Channel,
    ChannelGroup
}

export interface BackgroundInfo {
    name: string,
    height: number,
    width: number,
    folderPath: string,
    templates: Array<InfoValue>,
    channel: InfoValue
}

export interface BackgroundsFilterDtoIn {
    templateId: string,
    channelId: string
}

export interface ScreenSize {
    width: number,
    height: number
}

export enum ContentStatusEnum {
    Active = 1,
    Disabled = 0
}
export const ScreenSizes = [
    {
        value: { width: 0, height: 0 },
        text: "0x0"
    },
    {
        value: { width: 600, height: 1024 },
        text: "600x1024"
    },
    {
        value: { width: 768, height: 1024 },
        text: "768x1024"
    },
    {
        value: { width: 768, height: 1280 },
        text: "768x1280"
    },
    {
        value: { width: 768, height: 1360 },
        text: "768x1360"
    },
    {
        value: { width: 768, height: 1366 },
        text: "768x1366"
    },
    {
        value: { width: 800, height: 600 },
        text: "800x600"
    },
    {
        value: { width: 800, height: 1280 },
        text: "800x1280"
    },
    {
        value: { width: 1024, height: 600 },
        text: "1024x600"
    },
    {
        value: { width: 1024, height: 768 },
        text: "1024x768"
    },
    {
        value: { width: 1080, height: 1920 },
        text: "1080x1920"
    },
    {
        value: { width: 1200, height: 1920 },
        text: "1200x1920"
    },
    {
        value: { width: 1280, height: 768 },
        text: "1280x768"
    },
    {
        value: { width: 1280, height: 800 },
        text: "1280x800"
    },
    {
        value: { width: 1360, height: 768 },
        text: "1360x768"
    },
    {
        value: { width: 1366, height: 768 },
        text: "1366x768"
    },
    {
        value: { width: 1920, height: 1080 },
        text: "1920x1080"
    },
    {
        value: { width: 1920, height: 1200 },
        text: "1920x1200"
    },
    {
        value: { width: 3840, height: 2160 },
        text: "3840x2160"
    }
];
